import 'es6-promise/auto'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import the vue instance
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
//import VueResource from 'vue-resource'
import Home from './components/Home'
import Login from './components/Login'
import Logout from './components/Logout'
import Recover from './components/Recover'
import Reset from './components/Reset'
import Register from './components/Register'
import Downloads from './components/Downloads'
import Addorder from './components/Addorder'
import Keys from './components/Keys'
import Settings from './components/Settings'
import Transactions from './components/Transactions'
import Freeproduct from './components/Freeproduct'
import auth from './auth'
import VeeValidate from 'vee-validate'
import axios from 'axios'
import VueAxios from 'vue-axios'
import QS from 'qs'
import VueClipboard from 'vue-clipboard2'
import Switches from 'vue-switches'
import VueBrowserUpdate from 'vue-browserupdate'
import VueAnalytics from 'vue-analytics'
import JsonCSV from 'vue-json-csv'
import VueFacebookPixel from 'vue-analytics-fb'
import Popover from 'vue-js-popover'



//tell vue to use the router
//Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VeeValidate)
Vue.use(VueAxios, axios)
Vue.use(QS)
Vue.use(VueClipboard)
Vue.use(Switches)
Vue.use(VueFacebookPixel)
Vue.use(Popover)

Vue.component('downloadCsv', JsonCSV)

Vue.config.productionTip = false


axios.defaults.withCredentials = true

// Set config defaults when creating the instance
var instance = axios.create()
//export const loading = true

// Alter defaults after instance has been created
instance.defaults.baseURL = process.env.API_URL
instance.defaults.headers.common['Api-Key'] = process.env.API_KEY
instance.defaults.headers.common['Authorization'] = auth.getAuthHeader()
instance.defaults.headers.common['Cache-Control'] = 'no-store, must-revalidate'
instance.defaults.headers.common['Pragma'] = 'no-cache'
instance.defaults.headers.common['Accept'] = 'application/json'
instance.defaults.headers.common['Content-Type'] = 'application/json'
//instance.defaults.headers.common['Expires'] = '0'
instance.defaults.withCredentials = true



//define your routes
const routes = [
	{ path: '/', component: Home },
	{ path: '/login', component: Login },
  { path: '/recover', component: Recover },
  { path: '/forgotpassword', component: Recover },
  { path: '/register', component: Register },
  { path: '/logout', component: Logout},
  { path: '/downloads', component: Downloads},
  { path: '/keys', component: Keys},
  { path: '/add-order/:redeem_code', component: Addorder, name: 'addOrder'},
  { path: '/settings', component: Settings},
  { path: '/reset', component: Reset},
  { path: '/transactions', component: Transactions},
  { path: '/freeproduct/:token', component: Freeproduct}
]



//logut
  //localStorage.clear()
  //this.user.authenticated = false

// Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
export const router = new VueRouter({
  routes, // short for routes: routes
  mode: 'history'
})


//instatinat the vue instance
var app = new Vue({
//define the selector for the root component
  el: '#app',
  //pass the template to the root component
  template: '<App/>',
  //declare components that the root component can access
  components: { App },
  //pass in the router to the Vue instance
  router
}).$mount('#app')//mount the router on the app

/* BROWSER UPDATE*/
Vue.use(VueBrowserUpdate, {
    options: {
        // Your browser update options
        notify: {i:-5, f:-4, o:-4, s:-2, c:-4},
        reminder: 0,
        nomessage: true
    },
    test: false,
});
Vue.browserUpdate.onshow(() => {
          document.location.href='static/html/browser-update.html'
});




/*setTimeout(() => {
  auth.checkToken()
}, 1000);*/
setTimeout(() => {
  auth.checkAuth()
}, 1000);



// WEBPACK FOOTER //
// ./src/main.js